/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';

import { FETCH_ACES_SUBMITTED_APPLICATIONS } from './actionTypes';

import { fetchAcesSubmittedApplicationsUtil } from './utils';

/**
 * Contains the action creator functions that update the ACESSubmittedApplications slice of the store.
 *
 * @namespace ACESSubmittedApplicationsActions
 */
export default class actions {
  /**
   * Calls the api and dispatches the results to the store.
   * api: /v1/ua/aces_submitted_applications
   *
   * @param {any} callback function to call once this function has finished
   * @function
   * @memberof ACESSubmittedApplicationsActions
   */
  static fetchAcesSubmittedApplications = (dispatch, callback) => {
    ReduxUtils.generateAction(
      dispatch,
      fetchAcesSubmittedApplicationsUtil,
      FETCH_ACES_SUBMITTED_APPLICATIONS,
      callback
    );
  };

  /**
   * Dispatches the data to the store to reset the data cached from a call to fetchAcesSubmittedApplications.
   *
   * @param {function} dispatch
   * @param {Object} data object to be set in the store.
   * @function
   * @memberof ACESSubmittedApplicationsActions
   */
  static resetFetchAcesSubmittedApplications = (dispatch, data) => {
    const json = {
      type: FETCH_ACES_SUBMITTED_APPLICATIONS.successAction,
      payload: data,
    };
    dispatch(json);
  };

  /**
   * Dispatches the data to the store to reset the error cached from a call to fetchAcesSubmittedApplications.
   *
   * @param {function} dispatch
   * @function
   * @memberof ACESSubmittedApplicationsActions
   */
  static resetFetchAcesSubmittedApplicationsError = dispatch => {
    ReduxUtils.resetErrorAction(dispatch, FETCH_ACES_SUBMITTED_APPLICATIONS.failureAction);
  };
}
